import { render, staticRenderFns } from "./FactorDetailModal.vue?vue&type=template&id=62fd33da&scoped=true&"
import script from "./FactorDetailModal.vue?vue&type=script&lang=js&"
export * from "./FactorDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./FactorDetailModal.vue?vue&type=style&index=0&id=62fd33da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd33da",
  null
  
)

export default component.exports